import { useEffect } from 'react';

import type { UseRecordDetailsEffectsProps } from '@app/components/RecordModal/components/RecordDetails/types';

export const useRecordDetailsEffects = ({
  initForm,
  resetForm,
  importantEmployeeHandler,
  isOpen,
  handleConfirm,
  checkUnsavedData,
  isInitialized,
  hasChanges,
  getEmployeesByServicesHandler,
  checkRecordTimesHandler,
  employeePayoffHandler,
  getAllTagsHandler,
  closeRecordDetails,
  restoreSavedClientFields,
}: UseRecordDetailsEffectsProps) => {
  useEffect(() => {
    initForm();
  }, [initForm]);

  useEffect(() => {
    importantEmployeeHandler();
  }, [importantEmployeeHandler]);

  useEffect(() => {
    if (!isOpen) resetForm();
    return () => {
      closeRecordDetails();
    };
  }, [resetForm, isOpen, closeRecordDetails]);

  useEffect(() => {
    if (isOpen) handleConfirm();
  }, [handleConfirm, isOpen]);

  useEffect(() => {
    if (isOpen) getEmployeesByServicesHandler();
  }, [getEmployeesByServicesHandler, isOpen]);

  useEffect(() => {
    checkUnsavedData();
  }, [checkUnsavedData]);

  useEffect(() => {
    checkRecordTimesHandler();
  }, [checkRecordTimesHandler]);

  useEffect(() => {
    employeePayoffHandler();
  }, [employeePayoffHandler]);

  useEffect(() => {
    if (isOpen) getAllTagsHandler();
  }, [getAllTagsHandler, isOpen]);

  useEffect(() => {
    restoreSavedClientFields();
  }, [restoreSavedClientFields]);

  useEffect(() => {
    if (!isInitialized || !hasChanges) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isInitialized, hasChanges]);
};
